import {ActivatedRouteSnapshot, RouterStateSnapshot, Routes} from '@angular/router';
import {EventCalendarComponent} from './event-calendar.component';
import AuthenticatedBaseComponent from '../authenticated-base.component';
import {CanActivateGuard} from '../../guards/can-activate.guard';

const VIEWS = ['day', 'week', 'month'] as const;
type View = typeof VIEWS[number];

const canDeactivateFn = (
  component: AuthenticatedBaseComponent,
  currentRoute: ActivatedRouteSnapshot,
  currentState: RouterStateSnapshot,
  nextState: RouterStateSnapshot,
) => component.canDeactivate(currentRoute, currentState, nextState);

function buildCalendarRoute(view: View) {
  return {
    path: view,
    component: EventCalendarComponent,
    canActivate: [CanActivateGuard],
    data: {
      allPermissionsNeeded: [],
      breadcrumb: [{
        label: `authenticated.event_calendar.calendar_${view}.breadcrumb`,
        translate: true,
        route: `/event-calendar/${view}`,
      }],
    },
    resolve: {},
    canDeactivate: [canDeactivateFn],
  };
}

export const routes: Routes = [
  ...VIEWS.map(buildCalendarRoute),
  {
    path: '**',
    redirectTo: 'month',
  },
];
